module.exports = __webpack_public_path__ + "static/media/heavy-arrow.56b29a8a.svg";